export enum ColorScheme {
  LIGHT = "light",
  DARK = "dark",
  SYSTEM = "system"
}
